import React, { Component } from "react";
import { NavLink, withRouter, Switch, Route, Redirect } from "react-router-dom";
import { Menu, Segment, List, Container, Divider } from "semantic-ui-react";
import StickyFooter from "react-sticky-footer"

import { FacebookShareButton, FacebookShareCount, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from "react-share"



import Home from "./Containers/Home"
import Products from "./Containers/Products/Products"
import About from "./Containers/About"



export default class Layout extends Component {
  state = { activeItem: "Home" }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });


  render() {
    const { activeItem } = this.state;
    const shareUrl = 'https://rebrand.ly/phykraun';
    const title = 'Check out Phykraun\'s repository';

    return (
      <>
        <Menu stackable pointing secondary color="green">
          <Menu.Item
            as={NavLink}
            name="Home"
            active={activeItem === "Home"}
            exact
            to="/"
            onClick={this.handleItemClick}
          />
          <Menu.Item
            as={NavLink}
            name="Products"
            active={activeItem === "Products"}
            exact
            to="/products/bazaar_home/about"
            onClick={this.handleItemClick}
          />
          <Menu.Menu position="right">
            <Menu.Item
              as={NavLink}
              name="About Us"
              active={activeItem === "About Us"}
              exact
              to="/about_us"
              onClick={this.handleItemClick}
            />
          </Menu.Menu>

        </Menu>
        <Segment>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/about_us" component={About} />
            <Route path="/products" component={Products} />

            <Redirect to="/" />

          </Switch>
        </Segment>

        <StickyFooter>
          <Container textAlign="center">
            {/* <List horizontal divided inverted link size="small"> */}
            <List.Item as='a' target="_blank" href='https://www.facebook.com/Phykraun-109067940535183/'>
              Like us on FaceBook
          </List.Item>
                    <List.Item />
            <List.Item as='a' target="_blank" href='https://www.twitter.com/phykraun/'>
              Follow us on Twitter
           </List.Item>
            <List.Item />
            <List.Item>
              Contact us on mobile: +263 773 897 988
          </List.Item>
            <List.Item />
            <List.Item as='a' target="_blank" href='http://chat.whatsapp.com/GU9wWg54tEa8tkiSPVHiFd'>
              Contact us on WhatsApp
          </List.Item>
            <List.Item />

            <List.Item as='a' target="_blank" href="mailto: phykraun@gmail.com">
              Email us
            </List.Item>
            <List.Item />


            <List.Item>
              Share our website on:
            </List.Item>
            <List.Item />

            <List horizontal>
              <List.Item>

                <FacebookShareButton
                  url={shareUrl}
                  quote={title}
                  className="Demo__some-network__share-button">
                  <FacebookIcon
                    size={32}
                    round />
                </FacebookShareButton>
              </List.Item>

              <List.Item>

                <TwitterShareButton
                  url={shareUrl}
                  title={title}
                  className="Demo__some-network__share-button">
                  <TwitterIcon
                    size={32}
                    round />
                </TwitterShareButton>

              </List.Item>

              <List.Item>
                <WhatsappShareButton
                  url={shareUrl}
                  title={title}
                  separator=":: "
                  className="Demo__some-network__share-button">
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
              </List.Item>

            </List>

            <br />

            <List.Item as='small'>
              &copy; Copyright 2024, Phykraun
            </List.Item>
            <List.Item />

            {/* </List> */}
          </Container>
        </StickyFooter>
      </>
    )
  }
}